<template lang="pug">
  CoverSection.TourCover
    .CoverSection_background(ref="background")
      .CoverSection_background_asset
        AdaptativeImg(:derivatives="item.derivatives" :type="'cover'" :fit="true" :name="item.get('attributes.title')")

    .CoverSection_background_cache(ref="backgroundcache")
    PageTitle(:top="$tc('tour.tour')", :title="item.get('attributes.title')", :bottom="item.get('rel.tour_type.attributes.name')")
    .TourCover_footer(ref="footer")
      .TourCover_watch.Cta_round
        SvgInline(src="watch")
      p.TourCover_duration
        SvgInline(src="hourglass")
        span {{ $t('tour.visit_duration', { min: item.get('attributes.visit_duration') }) }}

      // ButtonPodcast( :url="item.get('attributes.podcast_url.uri')" )

      // ButtonSimple.TourCover_podcastBtn(class="ButtonSimple-with-background", :href="item.get('attributes.podcast_url.uri')", target="_blank", v-if="item.get('attributes.podcast_url.uri') != null")
        span.TourCover_podcastBtnLabel {{ $tc('tour.tour_podcast') }}
        span.TourCover_podcastBtnIcon
          SvgInline(src="extern")

    ScrollIndicator(
      orientation="vertical"
    )

</template>

<script>

import PageTitle from '@/components/common/PageTitle'
import ScrollIndicator from '@/components/ScrollIndicator'
import AdaptativeImg from '@/components/common/AdaptativeImg'
import SvgInline from '@/components/SvgInline'
import CoverSection from '@/components/common/CoverSection'

export default {
  props: ['item'],
  components: { PageTitle, SvgInline, CoverSection, ScrollIndicator, AdaptativeImg },
  mounted () {
    this.$parallax.set(this.$refs.footer, { opacity: 1 }, { opacity: 1 }, { opacity: 0 }, null, -0.1)
    this.$parallax.set(this.$refs.backgroundcache, { opacity: 0 }, { opacity: 0 }, { opacity: 1 }, null, -0.3)

    this.catchElement()
  },
  beforeDestroy () {
    this.detachElement()

    this.$parallax.remove(this.$refs.footer)
    this.$parallax.remove(this.$refs.backgroundcache)
    this.$refs.backgroundcache.removeEventListener('mousemove', this.captureMousePosition)
  },
  methods: {
    captureMousePosition (event) {
      this.rect = this.$refs.background.getBoundingClientRect()
      this.x = Math.floor((event.clientX - (this.rect.left + (this.rect.width / 2))) / 70)
      this.y = Math.floor((event.clientY - (this.rect.top + (this.rect.height / 2))) / 70)

      TweenMax.to(this.$refs.background, 2, { x: this.x, y: this.y, ease: Quint.easeOut })
    },
    catchElement () {
      if (!!('ontouchstart' in window) || !!('onmsgesturechange' in window)) return

      this.$refs.backgroundcache.addEventListener('mousemove', this.captureMousePosition)
    },
    detachElement () {
      this.$refs.backgroundcache.removeEventListener('mousemove', this.captureMousePosition)

      TweenMax.to(this.$refs.background, 1, { x: 0, y: 0, ease: Quint.easeOut })
    }
  }
}

</script>

<style lang="stylus" scoped>

$btn_size = 50px

.TourCover_podcastBtn

  text-decoration none !important

.TourCover

  z-index 2

  .CoverSection

    &_background

      opacity 0.25

  &_podcastBtn
    margin auto 0px auto auto

    @media (max-width: 930px)
      padding 0
      width $btn_size
      height $btn_size
      border-radius ($btn_size/2)
      display: flex
      align-items center
      justify-content: center

  &_podcastBtnLabel
    @media (max-width: 930px)
      display: none

  &_podcastBtnIcon
    svg
      @media (max-width: 930px)
        margin 0 !important

.TourCover_footer

  display flex
  flex-direction row
  width 100%
  box-sizing border-box
  padding 20px
  align-items center
  position absolute
  bottom 0px
  left 0px
  right 0px

  @media $mq_m
    padding 40px

  @media $mq_l
    padding 50px 50px 50px 100px

  .TourCover_watch

    height 50px
    width 50px
    cursor pointer
    border 1px solid $beige
    border-radius 50%
    box-sizing border-box
    margin auto auto auto 0px
    display flex
    flex-direction column

    svg

      width 22px
      height 17px
      margin auto

  .TourCover_duration

    margin auto
    color $beige
    position absolute
    left 50%
    transform translateX(-50%)
    text-align: center

    span

      vertical-align middle
      display inline-block
      font-size: 12px;
      letter-spacing: 2px;
      text-align: center;
      margin 0px

      @media $mq_m
        font-size: 14px;

    svg

      width 10px
      height 15px
      vertical-align middle
      display inline-block
      margin-right 10px

      @media $mq_m
        width 12px
        height 17px
        margin-right 15px

</style>
